<template>
 <div class="ui centered grid">
    <div class="four wide column"></div>
    <div class="eight wide column">
        <h4>Vítejte v databázi!</h4>
        <div class="ui embed"  data-url="https://www.youtube.com/embed/JYHxQSOSpiA" id="videoemb"></div><br><br>
       <!-- <h4>Snad databáze námi vytvořená potěší jeho císařské veličenstvo!</h4>
        <div class="ui embed"  data-url="https://www.youtube.com/embed/go1vqakrzNY" id="videoemb"></div>-->
      <!-- <iframe width="560" height="315" src="https://www.youtube.com/embed/go1vqakrzNY" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
    </div>
    <div class="four wide column"></div>
</div>


</template>

<script>
   // import TheCarousel from '../components/TheCarousel.vue'
    export default {
        name: 'video-r',
        data() {
            return {
            }
        },
        mounted(){
            setTimeout(function(){
             $('.ui.embed').embed();
            },100)
        },
        components: {
          //  TheCarousel
        },
    }
</script>

<style scoped>
    P{
         text-align: justify;
    }
</style>



// WEBPACK FOOTER //
// src/router/video.vue